import { VUserDetailsRequest, VUserDetailsResponse } from '@datarock/protobuffers';
import { EncryptedEndpoint } from './Encrypted';
class AccountDetailsEndpoint extends EncryptedEndpoint {
    async getRequestInit() {
        const requestBytes = VUserDetailsRequest.encode({
            includeCAP: false,
            capHash: new Uint8Array()
        }).finish();
        return await super.getRequestInit(requestBytes);
    }
    async process(value, ...args) {
        const responseBytes = await super.process(value, ...args);
        return VUserDetailsResponse.decode(responseBytes);
    }
}
export const accountDetailsEndpoint = new AccountDetailsEndpoint({
    path: '/pb/accounts/details',
    method: 'POST',
    sideEffect: true,
    schema: VUserDetailsResponse
});
